module.exports = __webpack_public_path__ + "static/media/maxDailyLogin_730_1095.854a1e7e.png";